module.exports = __webpack_public_path__ + "webauthn@2x.17042102cb41778d4389444f1e1bc7f2.png";